import { formatCurrencyAmount } from './planCatalogDisplay';

const normalizePlanName = (planName) => {
  if (planName === 'Pilot Basic') return 'Basic';
  if (planName === 'Pilot full') return 'All-in-One Bundle';
  if (planName === 'Report') return 'Reports';
  return planName || '—';
};

const formatBillingPeriod = (billingPeriod) => (
  billingPeriod === 'yearly' ? 'Yearly' : 'Monthly'
);

const formatAmountLine = (amount, billingPeriod) => {
  if (amount === undefined || amount === null) {
    return null;
  }
  const suffix = billingPeriod === 'yearly' ? '/ yr' : '/ mo';
  return `${formatCurrencyAmount(amount)} ${suffix}`;
};

const buildRows = ({ planName, billingPeriod, addonPlanNames = [], amount }) => {
  const rows = [
    { label: 'Plan', value: normalizePlanName(planName) },
    { label: 'Billing', value: formatBillingPeriod(billingPeriod) },
  ];

  if (addonPlanNames.length > 0) {
    rows.push({
      label: 'Add-ons',
      value: addonPlanNames.map(normalizePlanName).join(', '),
    });
  }

  const amountLine = formatAmountLine(amount, billingPeriod);
  if (amountLine) {
    rows.push({ label: 'Amount', value: amountLine });
  }

  return rows;
};

export const buildCheckoutSuccessResult = (checkoutSummary) => ({
  variant: 'success',
  title: 'Payment successful',
  subtitle: 'Your subscription is now active.',
  rows: buildRows({
    planName: checkoutSummary?.planName,
    billingPeriod: checkoutSummary?.billingPeriod,
    addonPlanNames: checkoutSummary?.addonPlanNames || [],
    amount: checkoutSummary?.amount,
  }),
});

export const buildActivePlanResult = (activePlan, plans = []) => {
  const billingPlan = activePlan?.billing;
  const planName = billingPlan?.planName || activePlan?.effective?.planName;
  const billingPeriod = activePlan?.subscription?.billingPeriod || 'monthly';
  const addonIds = Array.isArray(activePlan?.addons) ? activePlan.addons : [];
  const addonPlanNames = addonIds
    .map((addonId) => plans.find((plan) => String(plan._id) === String(addonId))?.planName)
    .filter(Boolean);

  const amount = billingPeriod === 'yearly'
    ? billingPlan?.yearlyPrice ?? billingPlan?.price
    : billingPlan?.monthlyPrice ?? billingPlan?.price;

  return {
    variant: 'success',
    title: 'Subscription updated',
    subtitle: 'Here is your current billing access.',
    rows: buildRows({
      planName,
      billingPeriod,
      addonPlanNames,
      amount,
    }),
  };
};

export const buildPaymentCancelledResult = () => ({
  variant: 'cancel',
  title: 'Payment cancelled',
  subtitle: 'No changes were made to your subscription.',
  rows: [],
});

export const buildBillingReturnResult = (activePlan, plans = []) => ({
  ...buildActivePlanResult(activePlan, plans),
  title: 'Billing updated',
  subtitle: 'Your subscription now matches your latest changes in Stripe.',
});
